import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=60d3b5a8&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=60d3b5a8&prod&scoped=true&lang=css"
import style1 from "./Textarea.vue?vue&type=style&index=1&id=60d3b5a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3b5a8",
  null
  
)

export default component.exports